import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet as HelmetComponent } from 'react-helmet';

type HelmetProps = {
    title?: string;
    description?: string;
    name?: string;
    type?: string;
};

function Helmet({
    title,
    description,
    name = 'The SAT Crash Course',
    type = 'website'
}: HelmetProps) {
    const location = useLocation();

    return (
        <HelmetComponent>
            <title>{title}</title>
            <meta name='description' content={description} />

            <meta property='og:title' content={title} />
            <meta property='og:description' content={description} />
            <meta property='og:url' content={process.env.CLIENT_BASE_URL + location.pathname} />
            <meta property='og:type' content={type} />

            <meta name='twitter:title' content={title} />
            <meta name='twitter:description' content={description} />
            <meta name='twitter:creator' content={name} />
            <meta name='twitter:card' content={type} />
        </HelmetComponent>
    );
}

export default Helmet;